<template>
  <div>
    <a-form labelAlign="right" class="container-wrapper" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
      <a-form-item label="上传至分组" class="upload-group">
        <a-select v-model:value="selectedGroupId" class="group-select">
          <a-select-option v-for="(item, key) in groupList" :value="item.group_id" :key="key">{{ item.name }}</a-select-option>
        </a-select>
        <a-button type="link" @click="addGroup()" v-if="!showUploadOnly">新建</a-button>
      </a-form-item>
      <a-form-item label="视频名称" v-if="showUploadOnly" class="video-title">
        <a-input v-model:value="videoName" />
        <p class="tip">若不填，则为视频原名称；若多个则会添加序号后缀，如：视频名称-1</p>
      </a-form-item>
      <a-form-item label="本地视频" class="upload-content">
        <div class="existing-new">
          <div class="upload-item" v-for="(item, index) of dataArr" :key="index">
            <template v-if="item.isFinished">
              <video :src="item.urlObj.videoSrc" controls class="video-player" @loadedmetadata="loadedmetadata(index)" :ref="'video-' + index"></video>
              <a-popconfirm title="确定删除该视频吗" ok-text="删除" cancel-text="取消" @confirm.stop="removeVideo(index)">
                <ehf-icon class="video-edit-btn" icon="delete-bin-6-line" @click="deletedBtnClicked"></ehf-icon>
              </a-popconfirm>
            </template>
            <template v-else>
              <div class="no-cursor">
                <span>（{{ item.percent }}%）</span>
              </div>
              <ehf-icon
                :class="['video-pause-btn', { play: !item.isPause }]"
                :icon="item.isPause ? 'play-line' : 'pause-circle-line'"
                @click="pasueVideo(index)"
              ></ehf-icon>
              <a-popconfirm title="确定取消上传视频吗" ok-text="删除" cancel-text="取消" @confirm.stop="removeUploadingVideo(index)">
                <ehf-icon v-show="item.isPause" class="video-edit-btn" icon="delete-bin-6-line" @click="deletedBtnClicked"></ehf-icon>
              </a-popconfirm>
            </template>
          </div>
          <div class="upload-item" v-show="canUpload" @click="videoBtn()" @drop.prevent.stop="fileDrop" @dragover.prevent>
            <ehf-icon icon="add-fill" class="upload-add-icon"></ehf-icon>
            <input type="file" class="input-video" :multiple="limitNumber > 1" @change="videoChange" ref="video" :accept="acceptList" @click.stop />
          </div>
        </div>
        <div class="tips">
          注意：
          <br />
          1.视频上传支持mp4格式
          <span v-show="limitNumber > 1">，至多选择{{ limitNumber }}个视频同时上传</span>
          ;
          <br />
          <span>2.单个视频上传最大支持{{ limitObj.text }}大小;</span>
          <template v-if="!isNull(limitTime)">
            <br />
            <span>3.单个视频最大时长{{ limitTime }};</span>
          </template>
        </div>
      </a-form-item>
    </a-form>

    <!-- 新增分组 -->
    <a-modal v-model:open="groupModal.show" title="新增分组" :confirmLoading="groupModal.confirmLoading" centered @ok="confirmSaveGroup">
      <a-form :model="groupModal" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="分组名称">
          <a-input v-model:value="groupModal.name" placeholder="请输入分组名称" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
  import { getMaterialGroupList as getMaterialGroupListAPI, saveMaterialGroup as saveMaterialGroupAPI } from '@/api/system/imageGroup'
  import { getQiniuConfig as getQiniuConfigAPI, getQiniuVideoUrl as getQiniuVideoUrlAPI } from '@/api/project/shoppingMall/courseManage'
  import * as qiniu from 'qiniu-js'
  import { nanoid } from 'nanoid'
  import { isNull } from '@/utils'
  const TYPE = 2 // 整型; 默认值: 1; 素材类型 1-图片 2-视频
  export default {
    name: 'UploadVideo',
    props: {
      // 最多能选几个视频
      limitNumber: {
        type: Number,
        default() {
          return 2
        },
      },
      // 视频最大size, 最大2GB
      limitObj: {
        type: Object,
        default() {
          return {
            text: '2GB',
            size: 2 * 1024 * 1024 * 1024,
          }
        },
      },
      // 视频最大时长
      limitTime: {
        type: String,
        default() {
          return '0'
        },
      },
      // 如果只展示上传tab页, 新增分组暂时隐藏
      showUploadOnly: {
        type: Boolean,
        default() {
          return false
        },
      },
      groupId: {
        type: String,
        default() {
          return '0'
        },
      },
    },
    emits: ['update:isUploading', 'update:videoCount'],
    data() {
      return {
        selectedGroupId: '0', // 默认未分组
        videoName: '', // 视频名字, 如果有多个视频, 请自行在后面加序列号,
        groupList: [],
        groupModal: {
          show: false,
          name: '',
          confirmLoading: false,
        },
        /*
          考虑到以后会有多个视频上传, 每次onloadmetaDuration 都是独立的,
          无法保证事件加载完, urlList一定会有对应的值, 时间顺序不固定
        */
        acceptList: ['video/mp4'], // 接收的规格列表
        /*
          id: 主键
          percent: 上传百分比
          urlObj: 值为对象, 就是对应的data中的urlList
            videoHash : qiniu 给的唯一id
            videoLink : //videocdn.ehafo.com/ + [videoHash] 组成的永久视频链接
            videoSrc  : 用[videoLink]向七牛申请临时播放地址
          originalFile: 值为对象, 文件的原始数据
          duration: 时长, 用onloadmetaDuration获取, 默认为''
          observable: qiniu.upload() 返回的对象
          subParams:  给subscribe传的参数
          subscriber: observable.subscribe() 返回的对象, 用于暂停的
          isFinished: boolean true为上传完毕
          isPause: boolean
        */
        dataArr: [],
        /* 
          如果删除视频被按下去, 则这个会变成true, 过了{delBtnBackNormalOffset}ms 再变成false
          会由于其他dom组件如果也在渲染 会导致删除弹窗渲染多次 明显的视觉效果
         */
        isdeletedBtnClicked: false,
        /*
          针对删除上传视频按钮的节流函数, 防止过于频繁发生, 导致上传进度一直不更新
        */
        throttleFnForDelBtn: null,
        delBtnBackNormalOffset: 50,
      }
    },
    methods: {
      isNull,
      // #region 分组相关函数 开始
      // 获取分组列表
      getGroupList() {
        getMaterialGroupListAPI({ type: TYPE }).then((res) => {
          if (parseInt(res.code) === 0) {
            const groups = res.data
            this.groupList = groups
          }
        })
      },
      confirmSaveGroup() {
        if (this.groupModal.name === '') {
          return this.$message.error('请填写分组名称')
        }
        const body = {
          group_id: '',
          name: this.groupModal.name,
          type: TYPE,
        }
        this.groupModal.confirmLoading = true
        saveMaterialGroupAPI(body)
          .then((res) => {
            this.groupModal.confirmLoading = false
            if (res.code === 0) {
              this.$message.success('保存成功')
              this.groupModal.show = false
              this.getGroupList()
            } else {
              this.$message.error('保存分组失败')
              console.error('保存分组失败', res)
            }
          })
          .catch(() => {
            this.groupModal.confirmLoading = false
          })
      },
      // 新增分组
      addGroup() {
        this.groupModal.show = true
      },
      // #endregion 分组相关函数 结束

      // #region 原生dom相关事件 开始
      videoChange(event) {
        if (event.target.files.length > this.remainNumber) {
          this.$message.error(`最多上传${this.limitNumber}个视频，还能上传${this.remainNumber}个视频`)
          this.$refs['video'].value = null
          return
        }
        Array.prototype.forEach.call(event.target.files, (file) => this.uploadFile(file))
        this.$refs['video'].value = null // 重置下input, 考虑到用户可能连续上传两次相同的文件
      },
      videoBtn() {
        this.$refs['video'].click()
      },
      fileDrop(event) {
        if (event.dataTransfer.files.length > this.remainNumber) {
          this.$message.error(`最多上传${this.limitNumber}个视频，还能上传${this.remainNumber}个视频`)
          return
        }
        Array.prototype.forEach.call(event.dataTransfer.files, (file) => this.uploadFile(file))
      },
      // 为了获取视频时长
      loadedmetadata(index) {
        this.dataArr[index].duration = this.$refs['video-' + index][0].duration
      },
      // #endregion 原生dom相关事件 结束

      // #region 视频相关函数 开始
      uploadFile(file) {
        if (!this.checkFileSize(file.size)) {
          this.$message.error(`单个文件最大不能超过 ${this.limitObj.text}`)
          return
        }
        let videoObj = {}
        let videoFile = file
        if (videoFile.type !== 'video/mp4') {
          this.$message.error('上传文件必须是 mp4 类型的文件')
          return
        }
        videoObj.url = URL.createObjectURL(videoFile)
        videoObj.time = 0
        let videoElement = document.createElement('video')
        videoElement.addEventListener('loadedmetadata', () => {
          videoObj.time = videoElement.duration.toFixed(2)
        })
        videoObj.src = videoObj.url
        videoObj.fileName = videoFile.name

        const key = null
        let config = {
          useCdnDomain: false, //表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
          region: qiniu.region.cnEast2, // 根据具体提示修改上传地区,当为 null 或 undefined 时，自动分析上传域名区域
          forceDirect: false, //强制选择不直传
        }
        let putExtra = {
          fname: videoFile.fileName, //文件原文件名
          params: {}, //用来放置自定义变量
          mimeType: videoFile.type,
        }

        let uptoken = null
        let progressKey = nanoid() // 记录当前上传所处的处置, 为了支持多个上传进度
        this.dataArr.push({
          id: progressKey,
          percent: 0,
          urlObj: null,
          originalFile: file,
          duration: '',
          observable: null,
          subParams: null,
          subscriber: null,
          isFinished: false,
          isPause: false,
        })
        this.notifyParent()
        getQiniuConfigAPI({ appoint_bucket: 'videolib', save_key: 'video_lib/$(etag)$(ext)' }).then((res) => {
          if (parseInt(res.code) === 0) {
            uptoken = res.data.token
            let url = res.data.url
            const OBSERVABLE = qiniu.upload(videoFile, key, uptoken, putExtra, config)
            const throttleFn = this.throttle(this.updateProgress, 700, false)
            const PARAMS = {
              next: (res) => {
                // 主要用来展示进度
                throttleFn(progressKey, res.total.percent.toFixed(2))
              },
              error: (err) => {
                // 失败报错信息
                if (err.code == 614) {
                  this.$message.error('视频文件已存在')
                } else {
                  this.$message.error('上传失败 请稍后再试')
                }
                console.error('上传失败: ', err)
                let tempDIndex = this.dataArr.findIndex((item) => item.index === progressKey)
                this.dataArr.splice(tempDIndex, 1)
                this.notifyParent()
              },
              complete: (secondRes) => {
                this.$message.success('上传成功')
                videoObj.videoHash = secondRes.hash
                videoObj.videoLink = url + '/' + secondRes.key
                if (videoObj.videoLink.includes('videolib')) {
                  // 无需请求解密的视频
                  videoObj.videoSrc = videoObj.videoLink
                  this.dataArr.forEach((item) => {
                    if (item.id === progressKey) {
                      item.urlObj = videoObj
                      item.isFinished = true
                    }
                  })
                  this.notifyParent()
                } else {
                  getQiniuVideoUrlAPI({ link: videoObj.videoLink })
                    .then((thirdRes) => {
                      if (parseInt(thirdRes.code) === 0) {
                        videoObj.videoSrc = thirdRes.data
                        this.dataArr.forEach((item) => {
                          if (item.id === progressKey) {
                            item.urlObj = videoObj
                            item.isFinished = true
                          }
                        })
                      } else {
                        this.$message.error('上传视频失败 稍微再试!')
                        console.error('请求七牛临时视频播放地址失败: ', thirdRes)
                        let tempDIndex = this.dataArr.findIndex((item) => item.index === progressKey)
                        this.dataArr.splice(tempDIndex, 1)
                      }
                    })
                    .catch((err) => {
                      this.$message.error('上传视频失败 稍微再试!!')
                      console.error('请求七牛临时视频播放地址失败: ', err)
                      let tempDIndex = this.dataArr.findIndex((item) => item.index === progressKey)
                      this.dataArr.splice(tempDIndex, 1)
                    })
                    .finally(() => {
                      this.notifyParent()
                    })
                }
              },
            }
            const SUBSCRIBER = OBSERVABLE.subscribe(PARAMS)
            this.dataArr.forEach((item) => {
              if (item.id === progressKey) {
                item.observable = OBSERVABLE
                item.subParams = PARAMS
                item.subscriber = SUBSCRIBER
              }
            })
          }
        })
      },
      removeVideo(index) {
        this.dataArr.splice(index, 1)
        this.notifyParent()
      },
      removeUploadingVideo(index) {
        this.dataArr.splice(index, 1)
        this.notifyParent()
      },
      pasueVideo(index) {
        if (this.dataArr[index].isPause) {
          // 每次重新播放, subscribe() 应该返回的是新的 SUBSCRIBER, 所以要重新保存
          const NEW_SUBSCRIBE = this.dataArr[index].observable.subscribe(this.dataArr[index].subParams)
          this.dataArr[index].subscriber = NEW_SUBSCRIBE
        } else {
          this.dataArr[index].subscriber.unsubscribe()
        }
        this.dataArr[index].isPause = !this.dataArr[index].isPause
      },
      // 单个文件上传的大小限制, 传进来的size应该是B
      checkFileSize(currSize) {
        if (currSize <= 0) {
          return false
        }
        if (currSize > this.limitObj.size) {
          return false
        }
        return true
      },
      // 通知父组件的调用 统一在一起
      notifyParent() {
        // 默认没有上传
        let isUploading = false
        let uploadedCount = 0
        this.dataArr.forEach((item) => {
          if (item.isFinished) {
            uploadedCount++
          } else {
            isUploading = true
          }
        })
        // 通知父组件 多少个已经上传完成的
        this.$emit('update:videoCount', uploadedCount)
        // 通知父组件 是否有正在上传的
        this.$emit('update:isUploading', isUploading)
      },
      updateProgress(id, progress) {
        this.dataArr.forEach((item) => {
          if (item.id === id) {
            // 如果准备更新时, 发现上传进度也要跟新了, 就延迟100ms再更新, 只延迟一次, 理论上有可能又遇到, 不考虑极限了
            if (this.isdeletedBtnClicked == true) {
              setTimeout(() => {
                item.percent = progress
              }, 100)
            } else {
              item.percent = progress
            }
          }
        })
      },
      /*
          节流函数
          {fn} 要执行的函数, 目前默认执行环境是this
          {interval} 间隔多久才允许继续执行 单位ms 默认700ms
          {isImmedate} 是否立即执行
        */
      throttle(fn, interval, isImmedate) {
        interval = interval ? interval : 700
        var timer = null
        var context = this
        return function () {
          let args = arguments
          if (isImmedate) {
            if (!timer) {
              fn.apply(context, args)
              timer = setTimeout(() => {
                fn.apply(context, args)
                timer = null
              }, interval)
            }
          } else {
            if (!timer) {
              timer = setTimeout(() => {
                fn.apply(context, args)
                timer = null
              }, interval)
            }
          }
        }
      },
      // 删除按钮触发的逻辑
      deleteBtnFn() {
        this.isdeletedBtnClicked = true
        setTimeout(() => {
          this.isdeletedBtnClicked = false
        }, this.delBtnBackNormalOffset)
      },
      deletedBtnClicked() {
        this.throttleFnForDelBtn()
      },
      // #endregion 视频相关函数 开始

      // #region 暴露函数 让父组件获取相关信息 开始
      // 针对富文本编辑器的信息检查 富文本编辑器只需要video 不需要名字
      checkInfoForEditor() {
        let result = this.basicCheckInfo()
        if (!result) {
          return false
        }
        return true
      },
      // 默认检查名字
      checkInfo(checkName = true) {
        let result = this.basicCheckInfo()
        if (!result) {
          return false
        }
        if (checkName && this.videoName.trim() === '') {
          this.$message.warn('请填写视频名称')
          return false
        }
        return true
      },
      // 基础信息检查 以后自定义检查都可以用
      basicCheckInfo() {
        // 默认没问题 当啥都没上传时没有视频可以获取时长
        let isStillUploading = false
        let validVideo = 0
        let isDurationFinished = true
        let zeroDurationFlag = false
        this.dataArr.forEach((item) => {
          if (item.isFinished) {
            validVideo++
          }
          if (!item.isFinished) {
            isStillUploading = true
          }
          if (item.duration === '') {
            isDurationFinished = false
          }
          if (item.duration == '0' || item.duration == 0) {
            zeroDurationFlag = true
          }
        })
        if (isStillUploading) {
          this.$message.warn('请等视频上传完毕')
          return false
        }
        if (validVideo === 0) {
          this.$message.warn('请上传视频')
          return false
        }
        if (!isDurationFinished) {
          this.$message.warn('视频过大，请等待视频加载完毕以获取时长')
          return false
        }
        if (zeroDurationFlag) {
          this.$message.warn('视频长度为0 请重新上传')
          return false
        }
        return true
      },
      // 用于父级获取相关信息的
      getInfo() {
        let groupName = ''
        // groupList是原始ajax的数据, 所以不是驼峰(group_id)
        let groupObj = this.groupList.filter((ele) => ele.group_id === this.selectedGroupId)
        if (groupObj === null || groupObj === undefined) {
          groupName = groupObj.name
        }
        let tempUrlArr = []
        let tempDuraArr = []
        let tempFileArr = []
        this.dataArr.forEach((item) => {
          tempUrlArr.push(item.urlObj)
          tempDuraArr.push(item.duration)
          tempFileArr.push(item.originalFile)
        })
        return {
          selectedGroupId: this.selectedGroupId, // 分组ID
          groupName: groupName,
          videoName: this.videoName.trim(), // 用户给文件取的名字
          fileArr: tempFileArr, // file类型的
          urlArr: tempUrlArr,
          durationArr: tempDuraArr,
        }
      },
      // 父级强制停止上传
      stopUploading() {
        this.dataArr.forEach((item) => {
          item.subscriber.unsubscribe()
        })
        this.dataArr = []
      },
      // #endregion 暴露函数 让父组件获取相关信息 结束
    },
    created() {
      this.getGroupList()
      // '' 是全部 '0'是未分组
      if (this.groupId === '') {
        this.selectedGroupId = '0'
      } else {
        this.selectedGroupId = this.groupId
      }
      this.throttleFnForDelBtn = this.throttle(this.deleteBtnFn, this.delBtnBackNormalOffset, false)
    },
    computed: {
      canUpload() {
        return this.limitNumber > this.dataArr.length
      },
      remainNumber() {
        // 最多能上传的 - 已经上传的 - 正在上传的
        return this.limitNumber - this.dataArr.length
      },
    },
  }
</script>

<style lang="scss" scoped>
  .container-wrapper {
    .upload-group {
      .group-select {
        width: 250px;
      }
    }
    .video-title {
      .tip {
        color: #999;
        font-size: 13px;
        line-height: initial;
      }
    }
    .upload-content {
      .existing-new {
        display: flex;
        .upload-item {
          width: 150px;
          height: 150px;
          cursor: pointer;
          border: 1px dashed #cccccc;
          margin-right: 10px;
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          .video-player {
            width: 100%;
            height: 100%;
            object-fit: contain;
            background-color: #000;
          }
          .upload-add-icon {
            font-size: 30px;
          }
        }
        .no-cursor {
          cursor: initial;
        }
        .video-edit-btn {
          position: absolute;
          top: 5px;
          right: 5px;
          color: red;
          cursor: pointer;
          font-size: 15px;
        }
        .video-pause-btn {
          position: absolute;
          top: 0;
          left: 3px;
          color: green;
          cursor: pointer;
          font-size: 23px;
        }
        .play {
          color: blue;
        }
        &:hover {
          .mock {
            display: block;
          }
        }
        .input-video {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 1;
          width: 100%;
          height: 100%;
          opacity: 0;
          display: none;
        }
      }
      .tips {
        color: #999;
        font-size: 13px;
        line-height: initial;
      }
    }
  }
</style>
